import Vuex from 'vuex'
import addbuy from './modules/addBuy'
import newbuy from './modules/newBuy'
import renewbuy from './modules/renewBuy'
import Order from './modules/Order'
import Vue from 'vue'
import global from '../global/'

Vue.use(Vuex)
export default new Vuex.Store({
    state: {
        orderInfo: null,
        otherOrderId: '',
        global
    },
    mutations: {
        setOrderInfo(state, payload) {
            state.orderInfo = payload
        },
        setOtherId (state, payload) {
            state.otherOrderId = payload
        }
    },
    getters: {
        
    },
    actions: {},
    modules: {
        addbuy,
        newbuy,
        renewbuy,
        Order
    }
})